import { createTheme } from '@mui/material'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown'
import CustomNoRowsOverlay from '../components/common/datagrid/CustomNoRowsOverlay'

export const dsThemeDark = createTheme({
  palette: {
    background: {
      default: '#020D06',
    },
    action: {
      main: '#19db55',
    },
    primary: {
      main: '#00c43d',
    },
    secondary: {
      main: '#19DB55',
    },
    tertiary: {
      main: '#66766B',
    },
    disabled: {
      main: 'hsl(236, 7%, 61%)',
    },
    error: {
      main: '#ff2b1b',
    },
    warning: {
      main: '#ff8a00',
    },
    text: {
      primary: '#F4FCF6',
    },
    toggle: {
      main: '#F4F8F6',
    },
  },
  drawer: {
    backgroundColor: '#242524',
  },
  typography: {
    root: {
      color: '#F4F8F6!important',
      fontFamily: 'Roboto, sans-serif',
    },
    text: {
      fontSize: '1rem',
    },
    text2: {
      fontSize: '1rem',
      fontWeight: '600',
    },
    text3: {
      fontSize: '0.75rem',
      fontWeight: '500',
    },
    text4: {
      fontSize: '1.25rem',
      fontWeight: '500',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: '500',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: '500',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: '500',
    },
    h5: {
      fontSize: '0.875rem',
      fontWeight: '400',
    },
    h6: {
      fontSize: '0.75rem',
      fontWeight: '600',
    },
    title: {
      fontSize: '1.25rem',
      fontWeight: '600',
    },
    title2: {
      fontSize: '0.875rem',
      fontWeight: '600',
    },
    title3: {
      fontSize: '1rem',
      fontWeight: '400',
      color: '#919D95',
    },
    title4: {
      fontSize: '1.25rem',
      fontWeight: '400',
    },
    subtitle1: {
      fontSize: '0.75rem',
      fontWeight: '600',
      color: '#919D95',
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: '600',
      color: '#F4FCF6',
    },
    subtitle3: {
      fontSize: '0.875rem',
      fontWeight: '400',
      color: '#919D95',
    },
    subtitle4: {
      fontSize: '0.75rem',
      fontWeight: '400',
      color: '#F4FCF6',
    },
    subtitle5: {
      fontSize: '1.25rem',
      fontWeight: '400',
      color: '#F4FCF6',
    },
    legend: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#F4FCF6',
    },
    number: {
      fontFamily: 'Roboto Mono, monospace',
      fontSize: '0.75rem',
      lineHeight: '1.25rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '1rem!important',
          backgroundColor: '#171B18',
          padding: '1rem',
          '&.MuiPopover-paper': {
            padding: '0px',
            backgroundColor: '#020D06',
          },
          '&.MuiPickersPopper-paper': {
            padding: '0px',
          },
          '&.MuiAccordion-root': {
            padding: '0px',
            border: 'none',
            borderRadius: '0.75rem!important',
          },
          '&.MuiDrawer-paper': {
            padding: '1rem!important',
          },
          '&.MuiDataGrid-paper': {
            backgroundColor: '#020D06!important',
            padding: '1rem',
          },
          '& ::-webkit-scrollbar-thumb': {
            background: '#57635b !important',
          },
        },
        rootTransparent: {
          backgroundColor: '#F4FCF633',
          padding: '1rem',
          borderRadius: '.75rem',
          border: '1px solid #E3EEE726',
        },
        rootOutlined: {
          backgroundColor: 'transparent',
          padding: '1rem 1.5rem',
          borderRadius: '.75rem',
          border: '1px solid #E3EEE726',
        },
        rootDashed: {
          backgroundColor: '#020D06',
          padding: '1.5rem 1rem',
          borderRadius: '1rem',
          border: '1px dashed #E3EEE726',
        },
        rootDashedTransparent: {
          backgroundColor: 'transparent',
          padding: '1.5rem 1rem',
          borderRadius: '1rem',
          border: '1px dashed #E3EEE726',
        },
        colorPrimary: {
          backgroundColor: '#242524',
          padding: '.75rem 1rem',
          borderRadius: '1rem',
        },
        colorPrimarySmall: {
          backgroundColor: '#242524',
          padding: '.5rem .75rem',
          borderRadius: '1rem',
        },
        colorSecondary: {
          backgroundColor: '#020D06',
          padding: '1.5rem 1rem',
          borderRadius: '1rem',
        },
        colorTertiary: {
          backgroundColor: '#020D06',
          padding: '1rem 1.5rem',
          borderRadius: '.75rem',
          border: '1px solid #E3EEE726',
        },
        colorDotted: {
          padding: '1rem 1.5rem',
          background: 'radial-gradient(circle at 1px 1px, #646565 calc(1px - 1px), #141414 1px) 0 0 / 22px 22px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          lineHeight: 'initial',
          fontSize: '0.75rem',
          color: '#F4FCF6',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          gap: '.25rem',
          padding: '0.25rem 0.75rem',
          width: 'fit-content',
         /*  backgroundColor: '#1c2820', */
          '& .MuiChip-icon': {
            margin: '0',
            color: '#919D95',
            height: '1rem',
            width: '1rem',
          },
          '& .MuiChip-label': {
            padding: '0 .25rem',
          },
        },
        colorPrimary: {
          backgroundColor: '#242524',
        },
        colorSecondary: {
          backgroundColor: '#020D06',
        },
        sliderSelected: {
          backgroundColor: '#19DB55',
          color: '#020D06',
          borderRadius: '100px',
          padding: '0.75rem 1.5rem',
          minHeight: '44px',
          fontSize: '1rem',
          textTransform: 'math-auto',
          '&:hover': {
            cursor: 'pointer',
          },
        },
        sliderTransparent: {
          backgroundColor: 'transparent',
          color: '#F4FCF6',
          fontSize: '1rem',
          fontWeight: '400',
          textTransform: 'math-auto',
          '&:hover': {
            cursor: 'pointer',
          },
        },
        sliderSelectedPurple: {
          backgroundColor: '#00C43D',
          color: '#F4FCF6',
          fontWeight: '500',
          borderRadius: '0.75rem',
          padding: '0.75rem',
          minHeight: '44px',
          fontSize: '1rem',
          textTransform: 'math-auto',
          '&:hover': {
            cursor: 'pointer',
          },
          '& .MuiChip-icon': {
            margin: '0',
            color: '#F4FCF6',
            height: '1.25rem',
            width: '1.25rem',
          },
        },
        slider: {
          backgroundColor: 'transparent',
          border: '1px solid #19DB55',
          color: '#19DB55',
          borderRadius: '100px',
          padding: '12px 24px 12px 24px',
          minHeight: '44px',
          fontSize: '1rem',
          textTransform: 'math-auto',
          fontWeight: '400',
          '& .MuiChip-label': {
            padding: '0',
          },
          '&:hover': {
            cursor: 'pointer',
          },
        },
        sliderWhite: {
          backgroundColor: '#020D06',
          border: '1px solid #3A423D',
          color: '#F4FCF6',
          borderRadius: '1.25rem',
          padding: '0.15rem 0.75rem',
          width: '100%',
          minHeight: '2.25rem',
          fontSize: '1.15rem',
          textTransform: 'math-auto',
          '&:hover': {
            cursor: 'pointer',
          },
        },
        sliderBlack: {
          backgroundColor: '#F4FCF6',
          color: '#171B18',
          borderRadius: '1.25rem',
          padding: '0.15rem 0.75rem',
          width: '100%',
          minHeight: '2.25rem',
          fontSize: '1.15rem!important',
          textTransform: 'math-auto',
          '&:hover': {
            cursor: 'pointer',
          },
          '&.Mui-selected': {
            color: '#19DB55',
            padding: '0.5rem 1.5rem',
            display: 'flex',
            alignItems: 'start',
            fontWeight: '500',
          },
        },
        transparent: {
          backgroundColor: 'transparent',
          border: '1px solid #C9D2CC',
          fontSize: '0.75rem',
          fontWeight: '400',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: '#919D95',
        },
        root: {
          borderRadius: '1rem',
          background: '#020D06',
          color: '#919D95',
          fontSize: '0.875rem',
          padding: '0.5rem 1rem',
          '&.Mui-disabled': {
            background: '#2c2d2c',
          },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          lineHeight: 'normal',
          '&.MuiCheckbox-root': {
            '&.Mui-disabled': {
              color: '#66756c',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: '2rem',
          display: 'flex',
          alignItems: 'center',
          padding: '.5rem 1.5rem',
          borderRadius: '0.75rem',
          lineHeight: 'normal',
          fontSize: '1rem',
          textTransform: 'math-auto',
          height: '2.25rem',

          '&.Mui-disabled': {
            backgroundColor: '#C9D2CC',
            color: '#66766B',
            border: 'none',
          },
        },
        contained: {
          backgroundColor: '#00C43D',
          color: '#F4FCF6',
          '&:hover': {
            backgroundColor: '#58ED87',
          },
        },
        outlinedChip: {
          fontSize: '0.75rem!important',
          textTransform: 'capitalize',
          height: '1.5rem!important',
          padding: '.25rem .5rem',
          backgroundColor: 'transparent',
          color: '#00b85f',
          border: '1px solid #00b85f',
          '&:hover': {
            border: '1px solid #58ED87',
            color: '#58ED87',
          },
        },
        outlinedChipError: {
          fontSize: '0.75rem!important',
          textTransform: 'capitalize',
          height: '1.5rem!important',
          padding: '.25rem .5rem',
          backgroundColor: 'transparent',
          border: '1px solid #FF2B1B',
          color: '#ff2b1b',
          '&:hover': {
            border: '1px solid #ff2b1b',
            color: '#ff2b1b',
          },
        },
        outlined: {
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          },
        },
        outlinedGrey: {
          backgroundColor: 'transparent',
          color: '#F4FCF6',
          border: '2px solid grey',
          '&:hover': {
            border: '2px solid grey',
            color: '#F4FCF6',
          },
        },
        outlinedBlank: {
          padding: '0.2rem',
          borderRadius: '0.5rem',
          border: '1.5px solid rgba(227, 238, 231, 0.15)',
          background: '#020D06',
          width: '2rem !important',
          height: '2rem !important',
          color: '#66766B',
          '&:hover': {
            border: '1.5px solid #C9D2CC',
            color: '#66766B',
          },
        },
        label: {
          border: '1px solid #C9D2CC',
          padding: '0.5rem 1rem',
          fontSize: '0.875rem',
          borderRadius: '6.25rem',
          fontWeight: '400',
        },
        action: {
          backgroundColor: '#020D06',
          padding: '0.5rem 1rem',
          border: '1px solid #020D06',
          color: '#FBFFFC',
          fontSize: '0.875rem',
          borderRadius: '1.5rem',
          '&:hover': {
            backgroundColor: '#020D06',
            border: '1px solid #020D06',
            color: '#FBFFFC',
          },
        },
        link: {
          fontSize: '1rem',
          color: '#F4FCF6',
          textDecoration: 'underline',
          fontWeight: '600',
          padding: '.5rem 1rem',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
        outlinedButton: {
          padding: '0.2rem',
          borderRadius: '0.5rem',
          border: '1.5px solid #F4FCF6',
          width: '2rem !important',
          height: '2rem !important',
        },
        outlinedButtonError: {
          padding: '0.2rem',
          borderRadius: '0.5rem',
          border: '1.5px solid #ff2b1b',
          width: '2rem !important',
          height: '2rem !important',
          svg: {
            fill: '#ffd7d4',
          },
        },
        outlinedButtonSuccess: {
          padding: '0.2rem',
          borderRadius: '0.5rem',
          border: '1.5px solid #00b85f',
          width: '2rem !important',
          height: '2rem !important',
          svg: {
            fill: '#cdf9e7',
          },
        },
        outlinedButtonAction: {
          padding: '0.2rem',
          borderRadius: '0.5rem',
          border: '1.5px solid #ff8a00',
          width: '2rem !important',
          height: '2rem !important',
          svg: {
            fill: '#f7e89b',
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontWeight: '600',
          color: '#19DB55',
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          borderRadius: '0.5rem',
          padding: '0.5rem',
          boxShadow: 'none',
          backgroundColor: '#171B18',
          color: '#919D95!important',
          '&:hover': {
            backgroundColor: '#2c2d2c',
          },
        },
        close: {
          color: '#F4FCF6',
          backgroundColor: '#020D06',
          border: '1.5px solid #E3EEE726',
          height: '2rem',
          width: '2.3rem',
          padding: '0.4rem',
        },
        select: {
          color: '#F4FCF6',
          backgroundColor: '#3A423D',
          border: '1.5px solid #E3EEE726',
          height: '2rem',
          width: '2.3rem',
          padding: '0.4rem',
        },
        action: {
          color: '#020D06',
          backgroundColor: '#3A423D',
          height: 'auto',
          width: 'auto',
          padding: '0.4rem',
        },
      },
    },
    MuiDataGrid: {
      defaultProps: {
        components: {
          NoRowsOverlay: CustomNoRowsOverlay,
        },
        slots: {
          noRowsOverlay: CustomNoRowsOverlay,
        },
      },
      styleOverrides: {
        root: {
          '& .MuiDataGrid-virtualScroller': {
            overflow: 'auto',
          },
          '--DataGrid-rowBorderColor': '#66766b',
          fontSize: '0.75rem',
          border: 'none',
          borderBottom: 'none',
          '&.MuiDataGrid-row': {
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
            height: '3rem',
          },
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            height: '48px',
            alignItems: 'center',
          },
          '& .MuiButtonBase-root.MuiIconButton-root': {
            color: '#919D95',
          },
          '& .MuiDataGrid-columnHeaderDraggableContainer': {
            height: '48px',
            alignItems: 'center',
          },
          '& .MuiDataGrid-columnsContainer': {
            background: '#010310',
          },
          '&& .MuiDataGrid-columnHeaders': {
            color: '#919D95',
            borderBottom: '1px solid #919D95',
          },
          '& .MuiDataGrid-container--top [role=row]': {
            background: '#171B18',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            height: '18px',
            lineHeight: '18px',
          },
          '& .MuiDataGrid-cell': {
            borderBottom: '1px solid #66766b',
            minHeight: '3rem !important',
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'pre-wrap !important',
          },
          '& ::-webkit-scrollbar-thumb': {
            background: '#57635b !important',
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '& .MuiSelect-icon': {
            right: '5px',
          },
        },
        actions: {
          margin: '0',
          '& svg': {
            color: '#919d95!important',
          },
        },
        select: {
          border: '1px solid #C9D2CC',
          borderRadius: '24px',
          margin: '0px',
          width: '3rem',
          display: 'flex',
          justifyContent: 'center',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#F4FCF6',
          border: '1.5px solid #E3EEE726',
          '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active':
            {
              transition: 'background-color 5000s ease-in-out 0s',
              backgroundColor: 'transparent !important',
              '-webkit-text-fill-color': '#F4FCF6 !important',
            },
        },
        input: {
          '&.MuiOutlinedInput-input': {
            padding: '0px',
            color: '#F4FCF6!important',
            '&.Mui-disabled': {
              '-webkit-text-fill-color': '#66756c !important',
            },
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          '& .MuiTabPanel': {
            padding: '0px',
          },
          '& .MuiTabs-flexContainer': {
            minWidth: '80px',
            gap: '.5rem',
          },
        },
        indicator: {
          backgroundColor: '#19DB55',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          margin: '0',
          padding: '0',
          fontWeight: '400',
          textTransform: 'capitalize',
          minWidth: '0',
          color: '#919D95',
          '&.Mui-selected': {
            color: '#19DB55',
            padding: '0',
            display: 'flex',
            alignItems: 'start',
            fontWeight: '500',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#F4FCF6',
          fontSize: '0.875rem',
          fontWeight: '600',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-root': {
            color: '#66766B',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '0.75rem 0.5rem',
          borderBottom: '1px solid #E3EEE70D',
        },
      },
    },
    MuiAccordion: {
      variants: [
        {
          props: { variant: 'light' },
          style: {
            backgroundColor: '#020D06',
          },
        },
        {
          props: { variant: 'medium' },
          style: {
            backgroundColor: '#242524',
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            backgroundColor: 'transparent',
            border: '1px solid #E3EEE726!important',
          },
        },
      ],
      styleOverrides: {
        root: {
          backgroundColor: '#171B18',
        },
      },
    },
    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: <KeyboardDoubleArrowDownIcon />,
      },
      styleOverrides: {
        root: {
          backgroundColor: 'transparent!important',
          padding: '1.25rem',
        },
        content: {
          margin: '0px!important',
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          borderRadius: '1rem',
          border: 'none!important',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          padding: '0rem 1.25rem 1.25rem 1.25rem!important',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingRight: '0!important',
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingRight: '0',
          paddingLeft: '0',
        },
      },
    },
    ListItemText: {
      styleOverrides: {
        root: {
          fontFamily: 'Roboto',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '20px',
          letterSpacing: '0em',
          textAlign: 'left',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: '#919D95',
          '&:hover': {
            cursor: 'pointer',
          },
          '& .MuiButtonBase-root.MuiIconButton-root': {
            color: '#919D95',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: '2rem',
          height: '1rem',
          padding: 0,
          '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
              transform: 'translateX(16px)',
              color: '#fff',
              '& + .MuiSwitch-track': {
                backgroundColor: '#00C43D',
                opacity: 1,
                border: 0,
              },
              '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
              },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: '#33cf4d',
              border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
              color: '#afb9b2',
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.7,
            },
          },
          '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: '.75rem',
            height: '.75rem',
          },
          '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
          },
        },
        large: {
          width: '2rem',
          height: '2rem',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-focusVisible': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          '& .modal': {
            backgroundColor: '#171B18',
          },
          '& ::-webkit-scrollbar-thumb': {
            background: '#57635b !important',
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: '#919D95',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#E3EEE70D',
          '&::before': {
            borderColor: '#E3EEE70D',
          },
          '&::after': {
            borderColor: '#E3EEE70D',
          },
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          '& .MuiPaper-root': {
            padding: '.25rem',
            border: '1px solid #919D95',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#919D95',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '&.MuiDayCalendar-weekDayLabel': {
            color: '#F4F8F6',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          '&.MuiSelect-icon': {
            color: '#919D95',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          '&.Mui-disabled': {
            color: '#66756c',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: {
          color: 'inherit!important',
        },
      },
    },
  },
})
